/**
 * Register page — Beta invitation notice.
 *
 * During the beta period, consumer accounts are created by platform admins.
 * This page informs visitors and provides contact options to request access.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Coins, Mail, ArrowLeft, ShieldCheck } from 'lucide-react';

export default function RegisterPage() {
  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 480 }}>
        <div className="auth-header">
          <Coins size={36} className="auth-logo" />
          <h1>Join the Beta</h1>
          <p>AI Tokens is currently in private beta</p>
        </div>

        <div className="register-beta-notice">
          <ShieldCheck size={20} />
          <div>
            <strong>Invitation Only</strong>
            <p>
              During the beta period, accounts are created by our team.
              We're onboarding users in batches to ensure quality and stability.
            </p>
          </div>
        </div>

        <div className="register-steps">
          <h3>How to get access</h3>
          <ol>
            <li>
              <span><strong>Request an invitation</strong> — reach out via the
              contact option below.</span>
            </li>
            <li>
              <span><strong>We'll set up your account</strong> — you'll receive
              an email with your login credentials and a token balance ready to go.</span>
            </li>
            <li>
              <span><strong>Start using AI</strong> — sign in and use your tokens
              across any AI-powered app that supports AI Tokens.</span>
            </li>
          </ol>
        </div>

        <div className="register-contact">
          <a
            href="mailto:contact@codetunezstudios.com?subject=AI%20Tokens%20Beta%20Access%20Request"
            className="btn btn-primary btn-block"
          >
            <Mail size={16} /> Request Access via Email
          </a>
        </div>

        <div className="register-footer">
          <p>
            Already have an account?{' '}
            <Link to="/login">Sign in</Link>
          </p>
          <p>
            <Link to="/">
              <ArrowLeft size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Back to home
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
